import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";


// 1️⃣ Get Broadcasts (Filters + Pagination)
export async function getBroadcasts(payload) {
  try {
    const fd = new FormData();

    fd.append("page_no", payload.page_no ?? 0);
    fd.append("search", payload.search || "");
    fd.append("channel", payload.channel || "");
    fd.append("status", payload.status || "");
    fd.append("from", payload.from || "");
    fd.append("to", payload.to || "");

    const res = await axios.post(
      `${apiBaseUrl}broadcastapis/get_broadcasts`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}


// 2️⃣ KPI Stats
export async function getBroadcastStats() {
  try {
    const fd = new FormData();

    const res = await axios.post(
      `${apiBaseUrl}broadcastapis/get_broadcast_stats`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Stats Request Failed" };
  }
}


// 3️⃣ Review Broadcast 🚨
export async function reviewBroadcast(broadcast_id, action = "clear") {
  try {
    const fd = new FormData();

    fd.append("broadcast_id", broadcast_id || "");
    fd.append("action", action || "clear");

    const res = await axios.post(
      `${apiBaseUrl}broadcastapis/review_broadcast`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Review Failed" };
  }
}
